const STORAGE_KEY = "wn_pending_email_confirmation_v1";
/** Set before `createUserWithEmailAndPassword` so auth-state listeners cannot
 *  navigate into the app before the uid is known. */
const SIGNUP_IN_PROGRESS = "signup";

/**
 * Marks that this session just created a password account whose address has not
 * been confirmed, so the app routes to `/verify-email` once instead of dropping
 * the new member straight onto the map.
 *
 * Shared state rather than component state on purpose: both `LoginForm` and the
 * signed-in redirect in `AuthPageGate` react to the same auth-state change, and
 * whichever runs first has to pick the same destination. A sentinel is stored
 * before Auth creates the user (no uid yet); it is replaced with the uid once
 * known so a later account cannot inherit the flag.
 */
export function markSignupAwaitingConfirmation(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, SIGNUP_IN_PROGRESS);
  } catch {
    // ignore quota / private mode
  }
}

export function markPendingEmailConfirmation(uid: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, uid);
  } catch {
    // ignore quota / private mode
  }
}

export function isPendingEmailConfirmation(uid: string | null | undefined): boolean {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return false;
    }
    if (stored === SIGNUP_IN_PROGRESS) {
      return true;
    }
    return Boolean(uid) && stored === uid;
  } catch {
    return false;
  }
}

export function clearPendingEmailConfirmation(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
